import React from 'react';
import WfbAdsComponent, { WfbCardSkeleton } from '@fuww/library/src/WfbAds';

const WfbAdsLoader = () => (
  <WfbAdsComponent
    className="loader"
    wfbAds={[
      <WfbCardSkeleton key={0} />,
      <WfbCardSkeleton key={1} />,
      <WfbCardSkeleton key={2} />,
      <WfbCardSkeleton key={3} />,
    ]}
  />
);

export const wfbAdsLoading = () => <WfbAdsLoader />;

export default WfbAdsLoader;
